import { Text, UnstyledButton } from '@mantine/core';
import { useState } from 'react';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

type Props = {
  onSave?: () => void;
};

export function SaveVersionCell({ onSave }: Props) {
  const [hovered, setHovered] = useState(false);
  const color = hovered ? 'var(--mantine-color-brand-5)' : 'var(--mantine-color-gray-2)';

  return (
    <UnstyledButton
      onClick={onSave}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      aria-label="Save new version"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 60,
        padding: 'var(--mantine-spacing-xs)',
        borderRadius: 12,
        border: `1px dashed ${color}`,
        cursor: 'pointer',
      }}
    >
      <Text size="xs" fw={FONT_WEIGHTS.medium} c={hovered ? 'brand.5' : 'gray.4'}>
        Save version
      </Text>
    </UnstyledButton>
  );
}
